import WebpackerReact from 'webpacker-react'
// 警告
import Filter from 'tools/filter'

WebpackerReact.setup({
  Filter,
})